import { Box, Typography, getContrastRatio,Checkbox, FormControlLabel, List, ListItem, Stepper, Step, StepLabel, LinearProgress, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import CustomAlert from "../../events/components/CustomAlert"
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/icons/CheckIcon";
import { useNavigate } from "react-router-dom";
import { generateLighterContrastColor } from "../../../utils/commonServices";
import useCustomTheme from "../../../theme/useCustomTheme";
import { updateProjectState } from "../../../redux/projectSlice";
import MediaFilesDropzone from "./MediaFilesDropzone";
import useSequentialVideoUpload from "../hooks/useSequentialVideoUpload";
import CustomTooltip from "../../../components/CustomTooltip";
import BoldCloseIcon from "../../../components/icons/BoldCloseIcon";
import useRevisionActions from "../useRevisionActions";
import useOrganisationProjectActions from "../../events/useOrganisationProjectActions";
import CustomVideoLinearProgress from "../../../components/CustomVideoLinearProgress";


const EditorCheckListUploadPopup = (props) => {
    // const { event  } = props
   
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const projectReducer = useSelector((state) => state.projectReducer);
    const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
    const [uploadedVideosArray, setUploadedVideosArray] = useState([]);
    // let label = getNamesFromIds(selectedBrandboxOption?.option_id, dropdownReducer.asset_options)?.name
    const [uploadedNotes , setUploadedNotes] = useState (projectReducer?.uploaded_event_notes)
    const [acceptType, setAcceptType] = useState('')
    const [disableSubmit, setDisableSubmit] = useState(true)
    const [theme] = useCustomTheme()
    const {getEditingCyclesList} = useRevisionActions()
    const {getProjectDetails} = useOrganisationProjectActions()
    // const [enableFileUpload, setEnableFileUpload] = useState(false)
    // const uploadedVideos = assetReducer?.all_assets?.find( option => option.label == label)?.files
    // const [requestController , setRequestController] = useState('')
    const { files, 
        setFiles,
        progress, 
        uploadStatus,
        setUploadStatus, 
        setProgress,
        isLoading,
        requestController, 
        setRequestController,
        stopUpload, 
        stopList ,
        enableFileUpload,
        setEnableFileUpload} = useSequentialVideoUpload(reviewEventReducer?.editing_cycle_id , false, uploadedNotes,  ()=>afterUploadCallback()) 
   
 

    const handleClose = () => {
      // setEnableFileUpload(false);
      // console.log({isLoading})
      if(isLoading === true){
        stopList( ()=> dispatch(updateProjectState({upload_video_popup : false}))  )
      }else{
        dispatch(updateProjectState({upload_video_popup : false}))      
      }
    };

    const items = [
        { id: 1, item: "Title was created." },
        { id: 2, item: "Used branding guidelines fonts, logos, colors etc" },
        { id: 3, item: "All favorited media was included" },
        { id: 4, item: "Everything is spelled correctly" },
        { id: 5, item: "The video is the appropriate length requested by the client" },
        { id: 6, item: "Color corrected" },
        { id: 7, item: "Audio Level is appropriate" },
        { id: 8, item: "Did you tell a story? Beginning, middle and End" },
        { id: 9, item: "All notes are addressed and NOT ignored (marked completed in frame)" },
        { id: 10, item: "File is exported with appropriate name" },
      ];
 

      const [checkedItems, setCheckedItems] = useState(Array(items.length).fill(false));

      const handleCheckboxChange = (index) => {
        const updatedCheckedItems = [...checkedItems];
        updatedCheckedItems[index] = !updatedCheckedItems[index];
        setCheckedItems(updatedCheckedItems);
      };
    
      const allChecked = checkedItems.every(Boolean);

  // const removeFileHandler =(file, index)=>{
  // const updatedFiles = files?.filter(data => data.name !== file.name)
  // if(!!enableFileUpload) {
  //   stopUpload(index)
  // } else {
  //   setUploadStatus((last) => {
  //     var temp = last?.filter((_, i) => i !== index);
  //     return temp;
  //   });
  //   setFiles(updatedFiles)
  // }
  
  // }

  useEffect(() => {
     setUploadedNotes(projectReducer?.uploaded_event_notes)

  }, [ projectReducer?.uploaded_event_notes])

  const afterUploadCallback =()=>{
    // getAllEventNotes({event_id: commonReducer?.production_event_id}, dispatch) api call
    getEditingCyclesList({event_id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id})
    getProjectDetails({id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id})
    handleClose()
  }

    return (
        <CustomAlert 
          open={projectReducer.upload_video_popup} 
          handleClose={handleClose} 
          height={{xs:'580px',md:'570px',lg:'570px' ,xl:'780px'}}
          // height={{xs:'550px',md:'610px',lg:'605px' ,xl:'700px'}}
          width={{xs:'600px',md:'770px',lg:'800px',xl:'1280px'}}
          >       
            <Box sx={{display:'flex', flexDirection:'column', height:'100%', }} px={4} pt={1} pb={2}>
              <Box flexGrow={1} pt={{xs:3,sm:1, md:1.5, lg:2.5, xl:3}} sx={{overflowY:'hidden'}} >    
                 
                  <Box className='flex col' gap={{xs:0.5, lg:1}}  sx={{ height:'100%', }}>
                    <Box className='flex j-between a-center' style={{width:{xs:'90%', md:'80%'}}}>
                      <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'#000', fontSize:{xs:'14px',sm:'14px',md:'16px',lg:'20px',xl:'30px'}}}>Editor Checklist</Typography>
                      
                    </Box>

                    
                    <Box pl={1} component='div' sx={{  maxHeight:allChecked ? {xs: '120px', sm: '110px', md: '200px', lg: '140px', xl: '200px'}: {xs: '200px', sm: '190px', md: '280px', lg: '260px', xl: '280px'} ,  maxWidth:'90%', width:'90%', mb:3, mt:1}}>
                          <Stepper  sx={{".MuiStepIcon-root": {width: "20px", height: "20px"},}} activeStep={checkedItems.filter(Boolean).length} alternativeLabel>
                               {items.map((item, index) => (
                                      <Step key={item.id} completed={checkedItems[index]}>
                                           <StepLabel></StepLabel>
                                       </Step>
                                         ))}
                          </Stepper>
                              <Box
                              sx={{
                                height: "100%",
                                overflowY: "auto",
                                borderRadius: "4px",
                                maxWidth:'100%',
                                backgroundColor:'#efefef99',
                                 boxShadow:'0px 5px 15px #00000029',
                                pl:2,
                                mt:1.3,
                                py:1,
                                  }}
                                >

                           
                                        {items.map((item, index) => (
                                         <Typography  sx={{fontSize:{xs:'10px !important',sm:'11px !important',md:'11px !important',lg:'13px !important',xl:'16px !important'}, fontWeight:500, letterSpacing:0, fontFamily:'Rubik', mt:0.8}} key={item.id} disablePadding>
                                          <FormControlLabel
                                           control={
                                            <Checkbox
                                            checked={checkedItems[index]}
                                            onChange={() => handleCheckboxChange(index)}
                                            sx={{ transform: "scale(0.85)", padding: 0,
                                                margin: 0, }}
                                            />
                                             }
                                             label={item.item}
                                             sx={{
                                                   margin: 0,
                                                   "& .MuiFormControlLabel-label": {
                                                      marginLeft: "4px",fontSize:{xs:'10px !important',sm:'11px !important',md:'11px !important',lg:'13px !important',xl:'16px !important'}
                                    },
                }}
                                             />
                                          </Typography>
                                        ))}
                                   
                                 </Box>

                     </Box>
          

                     
                  {   allChecked &&    <Box  sx={{height:'100px', width: '90%' , minWidth: '320px', marginTop:{xs: '20px', md: '10px'}, marginBottom:{xs:'10px', sm:'15px',md:'5px',lg:'25px', xl:'70px'}}}>
                        <MediaFilesDropzone
                         flex='row'
                         isDisabled={
                             isLoading
                           }
                         files={files}
                         setFiles={setFiles}
                         setUploadStatus={setUploadStatus}
                         setProgress={setProgress}
                         setRequestController={setRequestController}
                         height={{xs: '90px',sm:'85px',md:'85px',lg:'105px', xl:'150px'}}
                         setEnableFileUpload={setEnableFileUpload}
                       />
                        </Box>}
                        <Box height= '100%'  className= 'flex row j-between a-start' sx={{width:'100%', }}>
                      

                          <Box pl={1} component='div' sx={{  maxHeight: {xs: '130px', sm: '120px', md: '210px', lg: '150px', xl: '215px'} ,  maxWidth:'85%', width:'85%'}}>
                          <CustomVideoLinearProgress
                       progress={progress}
                       status={uploadStatus}
                       stopUpload={() => stopUpload()}
                       fontSize = {12}
                       bar = {5}
          /> 
                          {/* <Box sx={{ display: "flex", alignItems: "baseline", width:'100%' }}>
            <Box sx={{ width: "100%", mr: 1, mt: 2 }}>
              <LinearProgress
                variant="determinate"
                value={progress}
                style={{ height: 5, borderRadius: 5 }}
                sx={{
                  color: "#08231B",
                  backgroundColor: "#FFFFFF",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: theme.palette.primary.main,
                  },
                }}
              />
            </Box>
            <Box textAlign="right" >
              <Typography
                sx={{ color: "#08231B", fontSize: {xs:12*0.5, sm: 12*0.6,  md: 12*0.7, lg: 12*0.8 , xl: 12},  fontFamily: 'Rubik', }}
                
              >{`${Math.round(progress)}%`}</Typography>
            </Box>
            <Box>
              <CustomTooltip title="Cancel upload">
                <IconButton onClick={stopUpload}>
                  <BoldCloseIcon
                    style={{ color: "#08231B", fontSize: 12, fontWeight: 600, marginBottom: 0 }}
                  />
                </IconButton>
              </CustomTooltip>
            </Box>
          </Box> */}
                            {/* <UploadedDocumentsTable
                              progress= {progress} 
                              stopUpload = {stopUpload}
                              uploadStatus = {uploadStatus}
                              files = {files}
                              uploadedNotes={uploadedNotes}
                              stopList={stopList}
                              isUploading={isLoading}
                              height={{xs: '100px',sm:'85px',md:'100px',lg:'140px', xl:'180px'}}
                              setUploadedNotes={setUploadedNotes}
                            /> */}

                          </Box>
                        
                        <Box height= '100%' className='flex col j-end a-end'>
                          <CheckIcon  color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} 
                          onClick={()=> !isLoading && handleClose()}  
                          sx={{fontSize:{xs:'28px !important',sm:'30px !important',md:'42px !important', lg:'56px !important',xl:'75px !important'}, cursor:  !isLoading  &&  'pointer', opacity: isLoading  && 0.5}}/>
                        </Box>
                    </Box>
                  </Box>
  
              </Box>
          </Box>
       
        </CustomAlert>
      )
}

export default EditorCheckListUploadPopup